module.exports = __webpack_public_path__ + "media/images/gallery/solar_systems/galatea/galatea_uv-9c5b76bef362447ac431c6df3fc8223d.jpg";